import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { BookingService } from './booking.service';
import { BookingType } from '../booking-type.enum';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BookingViewModeService {

  readonly BOOKING_VIEW = 1;
  readonly STUDENT_VIEW = 2;
  readonly ACCOMMODATION_VIEW = 3;
  readonly PRE_CONFIRMATION_VIEW = 4;
  readonly FILES_VIEW = 5;
  readonly PAYMENTS_VIEW = 6;
  readonly BRUGES_VIEW = 7;
  readonly QUOTATIONS_VIEW = 8;
  readonly STUDENT_ZONE_VIEW = 9;
  readonly IMMERSION_VIEW = 10;
  readonly HIGH_SCHOOL_VIEW = 11;

  navigationItems: MenuItem[] = [];

    // show the following tab -> viewMode 1: Booking, mode 5: Student, mode 2: Confirmation, 
  // mode 3: Files, mode 4: Payments
  public selectedView = this.BOOKING_VIEW;
  public activeItemId = this.BOOKING_VIEW;
  public activeItem!: MenuItem;

  constructor(
    private userService: UserService,
    private bookingService: BookingService
  ) {}

  initNavigationItems(){
    this.navigationItems = [
      {
        id: "1", label: "Summary", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = this.BOOKING_VIEW;
          this.activateTab(this.activeItemId);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      // {
      //   id: "9", label: "Student Zone", command: () => {
      //     this.activeItemId = 9;
      //     this.activateTab(this.STUDENT_ZONE_VIEW);
      //   }, visible: this.userService.hasAnyRole(["admin", "editor"])
      // },
      {
        id: "2", label: "Student", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 2;
          this.activateTab(this.STUDENT_VIEW);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      {
        id: "3", label: "Accommodation", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 3;
          this.activateTab(this.ACCOMMODATION_VIEW);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      {
        id: "4", label: "Confirmation", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 4;
          this.activateTab(this.PRE_CONFIRMATION_VIEW);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      {
        id: "5", label: "Files", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 5;
          this.activateTab(this.FILES_VIEW);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      {
        id: "6", label: "Payments", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 6;
          this.activateTab(this.PAYMENTS_VIEW);
        }, visible: this.userService.hasAnyRole(["admin", "editor", "booking_viewer"])
      },
      {
        id: "7", label: "Bruges", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 7;
          this.activateTab(this.BRUGES_VIEW);
        }, visible: this.bookingService.isBrugesVndBooking
      },
      {
        id: "10", label: "Immersion", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 10;
          this.activateTab(this.IMMERSION_VIEW);
        }, visible: this.bookingService.booking.bookingType == BookingType.IMMERSION
      },
      {
        id: "11", label: "High School", command: () => {
          this.bookingService.sendingUpdateRequest = false;
          this.activeItemId = 11;
          this.activateTab(this.HIGH_SCHOOL_VIEW);
        }, visible: this.bookingService.booking.bookingType == BookingType.HIGH_SCHOOL
      }
    ];
    this.activeItem = this.navigationItems[0];
  }

  activateTab(mode: number) {
    this.selectedView = mode;
  }

  initViewMode(){
    this.selectedView = this.BOOKING_VIEW;
    this.activeItemId = this.BOOKING_VIEW;
    if(this.userService.hasRole("bruges_viewer")){
      this.selectedView = this.BRUGES_VIEW;
      this.activeItemId = this.BRUGES_VIEW;
    }
  }

  findMenuItemIndex(viewMode: number) {
    for (let item of this.navigationItems) {
      if (Number(item.id) == viewMode) {
        return item;
      }
    }
    return null;
  }
}
